import AddButton from '../authorised/impressionFinding/exam/findingActions/AddButton';

export default function InputWithIcon(props) {
const { input, readOnly, disabled, placeholder, autoComplete, wrapperClasses, wrapperSize, label, labelClasses, iconClasses, title, titleAppend, shouldRoundDecimalVal, maxLength, inputMode, meta: { touched, error, warning }, findingAutoComplete, handleOnAddFindings, FindingAutoCompleteComp, findingDropdownProps, findingWrapperClasses, helpText, handleIconClick } = props
  // const { input, readOnly, disabled, placeholder, autoComplete, wrapperClasses, wrapperSize, label, labelClasses, iconClasses, title, titleAppend, shouldRoundDecimalVal, maxLength, inputMode, meta: { touched, error, warning }, findingAutoComplete, handleOnAddFindings, FindingAutoCompleteComp, findingDropdownProps, findingWrapperClasses } = props

  return (
    <div className={`${disabled && 'disabled'} ${wrapperClasses}`}>
      {label !== undefined && <label className={labelClasses}>{props.label}</label>}
      <div className={`input-group ${wrapperSize}`}>
        <div className="input-group-prepend">
          {iconClasses !== undefined && <i className={`input-group-text ${iconClasses}`} onClick={handleIconClick} style={{ cursor: handleIconClick ? 'pointer' : 'default' }} />}
          {title !== undefined && <span className="input-group-text">{title}</span>}
        </div>
        <input
          {...input}
          value={shouldRoundDecimalVal ? input.value?.toFixed(shouldRoundDecimalVal) : input.value}
          autoComplete={autoComplete}
          placeholder={placeholder}
          type={props.type}
          readOnly={readOnly}
          disabled={props.disabled || false}
          maxLength={maxLength}
          inputMode={inputMode}
          className={`${props.className}  ${touched && error && 'is-invalid'}`}
        />
        {titleAppend !== undefined &&
          <div className="input-group-append">
            <span className="input-group-text">{titleAppend}</span>
          </div>}
        {findingAutoComplete && <AddButton name={input.name} value={input.value} handleOnAddFindings={handleOnAddFindings} />}
      </div>
      {FindingAutoCompleteComp && (
        <div className={findingWrapperClasses}>
          <FindingAutoCompleteComp {...findingDropdownProps} />
        </div>
      )}

      {helpText && (
        <small
          className="form-text text-muted"
          style={{ display: "block", marginTop: "4px" }}
        >
          {helpText}
        </small>
      )}

      {touched &&
        ((error && <span className="error-msg text-danger">{error}</span>) ||
          (warning && <span>{warning}</span>))}
      {/* {touched &&
        ((error && <span className="error-msg text-danger">{error}</span>) ||
          (warning && <span>{warning}</span>))} */}
      {/* { touched && (error && <i className={`la la-warning text-danger ${label === undefined ? 'error-icon' : 'error-icon-label'}`}></i>)} */}
    </div>
  )
}
